import type { TopicVocabulary } from "./dialog-data";

/**
 * Empty vocabulary object for components that need a default
 */
export const EMPTY_VOCABULARY: TopicVocabulary = {
  words: [],
  expressions: [],
  topical: [],
};
